import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import VerifyIcon from "../../../Common/Svgs/VerifyIcon";
import ZoomButton, {
  RelocateButton,
} from "../../../Core/Components/MapMarkerButtons";

const MapBottomCard = ({ mapRef, initialZoomLevel, center }) => {
  const { currentRental } = useSelector((state) => state.rentals);

  return (
    <div className="absolute left-0 right-0 z-20 w-full bottom-6">
      <Row gutter={16}>
        <Col span={21}>
          <div className="p-3 ml-6 bg-white rounded-md h-27">
            <div className="flex justify-between">
              <div className="flex items-center gap-x-2">
                <div className="text-base font-medium capitalize font-poppins text-new-black">
                  {currentRental?.firstName} {currentRental?.lastName}
                </div>

                <VerifyIcon />
              </div>
            </div>

            <div className="text-10 font-light font-poppins leading-3.75 text-dark-grey-text">
              Driver
            </div>

            <div className="mt-4 flex items-center gap-x-8">
              <div className="flex-1">
                <p className="font-aileron font-normal text-10 text-dark-gray">
                  Distance
                </p>

                <p className="font-aileron font-semibold text-xs text-black">
                  -- Km
                </p>
              </div>

              <div className="flex-1">
                <p className="font-aileron font-normal text-10 text-dark-gray">
                  Max. Speed
                </p>

                <p className="font-aileron font-semibold text-xs text-black">
                  20 Km/H
                </p>
              </div>

              <div className="flex-1">
                <p className="font-aileron font-normal text-10 text-dark-gray">
                  Avg. Speed
                </p>

                <p className="font-aileron font-semibold text-xs text-black">
                  -- Km/H
                </p>
              </div>
            </div>
          </div>
        </Col>

        <Col span={3}>
          <div className="flex flex-col gap-y-3">
            <RelocateButton
              mapRef={mapRef}
              initialZoomlevel={initialZoomLevel}
              center={center}
            />

            <ZoomButton mapRef={mapRef} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MapBottomCard;
